import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const DragDropIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9091 5.45479C14.5074 5.45479 14.1818 5.12918 14.1818 4.72752C14.1818 4.32586 14.5074 4.00024 14.9091 4.00024C15.3108 4.00024 15.6364 4.32586 15.6364 4.72752C15.6364 5.12918 15.3108 5.45479 14.9091 5.45479Z"
        fill={iconColor}
      />
      <path
        d="M14.9091 12.7275C14.5074 12.7275 14.1818 12.4019 14.1818 12.0002C14.1818 11.5986 14.5074 11.273 14.9091 11.273C15.3108 11.273 15.6364 11.5986 15.6364 12.0002C15.6364 12.4019 15.3108 12.7275 14.9091 12.7275Z"
        fill={iconColor}
      />
      <path
        d="M14.9091 20.0002C14.5074 20.0002 14.1818 19.6746 14.1818 19.273C14.1818 18.8713 14.5074 18.5457 14.9091 18.5457C15.3108 18.5457 15.6364 18.8713 15.6364 19.273C15.6364 19.6746 15.3108 20.0002 14.9091 20.0002Z"
        fill={iconColor}
      />
      <path
        d="M9.09092 5.45479C8.68926 5.45479 8.36365 5.12918 8.36365 4.72752C8.36365 4.32586 8.68926 4.00024 9.09092 4.00024C9.49258 4.00024 9.81819 4.32586 9.81819 4.72752C9.81819 5.12918 9.49258 5.45479 9.09092 5.45479Z"
        fill={iconColor}
      />
      <path
        d="M9.09092 12.7275C8.68926 12.7275 8.36365 12.4019 8.36365 12.0002C8.36365 11.5986 8.68926 11.273 9.09092 11.273C9.49258 11.273 9.81819 11.5986 9.81819 12.0002C9.81819 12.4019 9.49258 12.7275 9.09092 12.7275Z"
        fill={iconColor}
      />
      <path
        d="M9.09092 20.0002C8.68926 20.0002 8.36365 19.6746 8.36365 19.273C8.36365 18.8713 8.68926 18.5457 9.09092 18.5457C9.49258 18.5457 9.81819 18.8713 9.81819 19.273C9.81819 19.6746 9.49258 20.0002 9.09092 20.0002Z"
        fill={iconColor}
      />
      <path
        d="M14.9091 5.45479C14.5074 5.45479 14.1818 5.12918 14.1818 4.72752C14.1818 4.32586 14.5074 4.00024 14.9091 4.00024C15.3108 4.00024 15.6364 4.32586 15.6364 4.72752C15.6364 5.12918 15.3108 5.45479 14.9091 5.45479Z"
        stroke={iconColor}
      />
      <path
        d="M14.9091 12.7275C14.5074 12.7275 14.1818 12.4019 14.1818 12.0002C14.1818 11.5986 14.5074 11.273 14.9091 11.273C15.3108 11.273 15.6364 11.5986 15.6364 12.0002C15.6364 12.4019 15.3108 12.7275 14.9091 12.7275Z"
        stroke={iconColor}
      />
      <path
        d="M14.9091 20.0002C14.5074 20.0002 14.1818 19.6746 14.1818 19.273C14.1818 18.8713 14.5074 18.5457 14.9091 18.5457C15.3108 18.5457 15.6364 18.8713 15.6364 19.273C15.6364 19.6746 15.3108 20.0002 14.9091 20.0002Z"
        stroke={iconColor}
      />
      <path
        d="M9.09092 5.45479C8.68926 5.45479 8.36365 5.12918 8.36365 4.72752C8.36365 4.32586 8.68926 4.00024 9.09092 4.00024C9.49258 4.00024 9.81819 4.32586 9.81819 4.72752C9.81819 5.12918 9.49258 5.45479 9.09092 5.45479Z"
        stroke={iconColor}
      />
      <path
        d="M9.09092 12.7275C8.68926 12.7275 8.36365 12.4019 8.36365 12.0002C8.36365 11.5986 8.68926 11.273 9.09092 11.273C9.49258 11.273 9.81819 11.5986 9.81819 12.0002C9.81819 12.4019 9.49258 12.7275 9.09092 12.7275Z"
        stroke={iconColor}
      />
      <path
        d="M9.09092 20.0002C8.68926 20.0002 8.36365 19.6746 8.36365 19.273C8.36365 18.8713 8.68926 18.5457 9.09092 18.5457C9.49258 18.5457 9.81819 18.8713 9.81819 19.273C9.81819 19.6746 9.49258 20.0002 9.09092 20.0002Z"
        stroke={iconColor}
      />
    </Box>
  );
};
